import { axiosInstance } from '../client';

export const cashDrawerService = {
  open: (data: { opening_balance: number; notes?: string }) =>
    axiosInstance.post<CashDrawer>('/api/v1/cash-drawers/open', data),
  close: (
    id: string,
    data: { actual_cash: number; expected_cash: number; closing_balance: number; notes?: string },
  ) => axiosInstance.post<CashDrawer>(`/api/v1/cash-drawers/${id}/close`, data),
  current: () => axiosInstance.get<CashDrawer>('/api/v1/cash-drawers/current'),
};

export interface CashDrawer {
  id: string;
  user_id: string;
  opening_balance: number;
  closing_balance?: number;
  expected_cash?: number;
  actual_cash?: number;
  variance?: number;
  status: string;
  opened_at: string;
  closed_at?: string;
  notes?: string;
}
